export const getRedirectLinkFromUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('redirectUrl') ?? '';
};
